import { render, staticRenderFns } from "./MatrixSection.vue?vue&type=template&id=1b1c85b7&scoped=true"
import script from "./MatrixSection.vue?vue&type=script&lang=js"
export * from "./MatrixSection.vue?vue&type=script&lang=js"
import style0 from "./MatrixSection.vue?vue&type=style&index=0&id=1b1c85b7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1c85b7",
  null
  
)

export default component.exports